// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"fa3ccc8a","458":"da1beced","594":"d375bd40","774":"6e9e91db","820":"67fa15e2","836":"2d6a100a","858":"2a97e916"}[chunkId] + ".chunk.js";
};